module.exports = "<div>\n  {{ getReference() }}\n</div>";